import { Box, Button, Dialog, DialogContent, DialogTitle, ModalProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';
import BaseRow from '../base-row/BaseRow';

type ConfirmDialogProps = Omit<ModalProps, 'children'> & {
  title?: string;
  description?: string;
  confirm?: string;
  cancel?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
};

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { t } = useTranslation(['admin/component']);
  return (
    <Dialog
      open={props.open}
      onClose={() => {
        if (props?.onCancel) props.onCancel();
      }}
      className='text-center'
      PaperProps={{
        sx: {
          minWidth: '400px',
        },
      }}
    >
      <DialogTitle className='bg-[#ED1002]'>{props.title}</DialogTitle>
      <DialogContent>
        {props?.description ? (
          <Box className='mb-[20px]' dangerouslySetInnerHTML={{ __html: props?.description }}></Box>
        ) : null}
        <BaseRow className='!justify-evenly'>
          <Button
            variant='outlined'
            color='secondary'
            className='min-w-[125px]'
            onClick={() => {
              if (props?.onCancel) props.onCancel();
            }}
          >
            {props?.cancel || t('confirmDialog.cancel')}
          </Button>
          <Button
            variant='contained'
            color='secondary'
            className='min-w-[125px]'
            onClick={() => {
              if (props?.onConfirm) props.onConfirm();
            }}
          >
            {props?.confirm || t('confirmDialog.confirm')}
          </Button>
        </BaseRow>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ConfirmDialog);
